import { GridItemNormalizer } from '../types';

export default class ClientObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_Client';
  }

  normalize(value: any) {
    return value?.legal_name;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      legal_name: '',
    };
  }
}
